import Slider from "./slider";

export { Slider as InspirationSlider };
